import { Component, OnInit, ViewChild } from "@angular/core";
import { first, startWith, catchError, map, switchMap } from "rxjs/operators";
import { ChartViewDTO } from "../../core/model/chart_view/chart-view-dto";
import * as Highcharts from "highcharts";
import { DashboardImpayeServiceService } from '../../core/service/suiviPortefeuille/dashboard-impaye-service.service';
import { QuantiteDossierPrecontentieuxDTO } from '../../core/model/QuantiteDossierPrecontentieuxDTO';
import { QuantiteDossierImpayeDTO } from '../../core/model/QuantiteDossierImpayeDTO';

import { merge, Observable, of as observableOf } from "rxjs";

import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { DossierDTO } from 'src/app/suivi-portefeuille/core/model/DossierDTO';


@Component({
  selector: "app-dossier-impaye",
  templateUrl: "./dossier-impaye.component.html",
  styleUrls: ["./dossier-impaye.component.scss"]
})
export class DossierImpayeComponent implements OnInit {
  highcharts = Highcharts;
  dossiers: DossierDTO[];

  nombreByPeriode: ChartViewDTO;
  chartOptionsSuiviByPeriode: any;

  nombreCumulByPeriode: ChartViewDTO;
  chartOptionsCumulSuiviByPeriode: any;

  quantiteByPeriode: ChartViewDTO;
  chartOptionsQuantiteByPeriode: any;

  evolutionNombreByPeriode: ChartViewDTO;
  chartOptionsSuivievolutionNombreByPeriode: any;

  //quantiteDossierImpayeDTO: QuantiteDossierImpayeDTO[];

  updateFlagPourcentage: boolean = false;
  updateFlagDossierCree: boolean = false;
  chartOptionsPourcentageParticulier: any;
  chartOptionsPourcentagePme: any;
  chartOptionsPourcentageCorporate: any;

  hasDataPourcentageParticulier: boolean = false;
  hasDataPourcentageCorporate: boolean = false;
  hasDataPourcentagePme: boolean = false;

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  displayedColumns: string[] = [
    "numDossier",
    "typeDossier",
    "description",
    "bankLabel",
    "nomClient",
    "montantPret",
    "resteAPayer",
    "impayeJour",
    "taskName"
  ];

  constructor(
    private _dashboardImpayeServiceService: DashboardImpayeServiceService
  ) {}

  ngOnInit() {
    this.nombreCumulativeDossier();
    this.quantiteDossierContentieux();
    this.EvolutionnombreDossierParMois();
    this.pourcentageDossierByTypeMarcheParticulier();
    this.pourcentageDossierByTypeMarchePme();
    this.pourcentageDossierByTypeMarcheCorporate();
  }

  ngAfterViewInit(): void {
    this.getPageDossier("_", 0);
  }

  nombreCumulativeDossier() {
    this._dashboardImpayeServiceService
      .nombreCumulativeDossier()
      .pipe(first())
      .subscribe(
        response => {
          this.nombreCumulByPeriode = response;

          this.chartOptionsCumulSuiviByPeriode = {
            chart: {
              type: "spline"
            },
            title: {
              text:
                "Évolution Cumulative des Impayés sur les 6 Derniers Mois pour les Dossiers en recouvrement"
            },
            subtitle: {
              text: null
            },
            xAxis: {
              categories: this.nombreCumulByPeriode.categories
            },
            yAxis: {
              title: {
                text: "Qté"
              }
            },
            tooltip: {
              valueSuffix: null
            },

            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              x: 0,
              y: 100,
              floating: false,
              borderWidth: 1,

              backgroundColor: "#FFFFFF",
              shadow: true
            },

            series: this.nombreCumulByPeriode.series
          };
        },
        error => {
          console.log(error);
        }
      );
  }

  EvolutionnombreDossierParMois() {
    this._dashboardImpayeServiceService
      .nombreDossierContentieux()
      .pipe(first())
      .subscribe(
        response => {
          this.nombreByPeriode = response;

          this.chartOptionsSuiviByPeriode = {
            chart: {
              type: "spline"
            },
            title: {
              text:
                "Évolution des Impayés sur les 12 Derniers Mois pour les Dossiers en recouvrement"
            },
            subtitle: {
              text: null
            },
            xAxis: {
              categories: this.nombreByPeriode.categories
            },
            yAxis: {
              title: {
                text: "Qté"
              }
            },
            tooltip: {
              valueSuffix: null
            },

            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              x: 0,
              y: 100,
              floating: false,
              borderWidth: 1,

              backgroundColor: "#FFFFFF",
              shadow: true
            },

            series: this.nombreByPeriode.series
          };
        },
        error => {
          console.log(error);
        }
      );
  }

  quantiteDossierContentieux() {
    this._dashboardImpayeServiceService
      .quantiteDossierContentieux()
      .pipe(first())
      .subscribe(
        response => {
          this.quantiteByPeriode = response;

          this.chartOptionsQuantiteByPeriode = {
            chart: {
              type: "column" // Changer le type en "column"
            },
            title: {
              text: "Quantité de dossier sur les 12 derniers mois"
            },
            subtitle: {
              text: null
            },
            xAxis: {
              categories: this.quantiteByPeriode.categories
            },
            yAxis: {
              title: {
                text: "Qté"
              }
            },
            tooltip: {
              valueSuffix: null
            },

            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              x: 0,
              y: 100,
              floating: false,
              borderWidth: 1,

              backgroundColor: "#FFFFFF",
              shadow: true
            },

            plotOptions: {
              column: {
                stacking: "normal", // Ajouter cette ligne pour empiler les colonnes
                dataLabels: {
                  enabled: true
                }
              }
            },

            series: this.quantiteByPeriode.series
          };
        },
        error => {
          console.log(error);
        }
      );
  }


  pourcentageDossierByTypeMarcheParticulier() {
    this._dashboardImpayeServiceService
      .pourcentageDossierImpayeTypeMarche("PARTICULIER")
      .pipe(first())
      .subscribe(
        response => {
          const data = [];
          response.forEach(function(value) {
            data.push({ name: value.name, y: value.valeur });
          });
          this.hasDataPourcentageParticulier = data.length > 0;

          this.chartOptionsPourcentageParticulier = {
            chart: {
              plotBorderWidth: null,
              plotShadow: false
            },
            title: {
              text: "Répartition des dossiers de particulier"
            },
            tooltip: {
              pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>"
            },
            plotOptions: {
              pie: {
                allowPointSelect: true,
                cursor: "pointer",

                dataLabels: {
                  enabled: false
                },

                showInLegend: true
              }
            },
            series: [
              {
                type: "pie",
                name: "Pourcentage",
                data: data
              }
            ]
          };
          if (data.length > 0) {
            this.updateFlagPourcentage = true;
          }
        },
        error => {
          console.log(error);
        }
      );
  }

  pourcentageDossierByTypeMarchePme() {
    this._dashboardImpayeServiceService
      .pourcentageDossierImpayeTypeMarche("PROFESSIONNEL")
      .pipe(first())
      .subscribe(
        response => {
          const data = [];
          response.forEach(function(value) {
            data.push({ name: value.name, y: value.valeur });
          });
          this.hasDataPourcentagePme = data.length > 0;

          this.chartOptionsPourcentagePme = {
            chart: {
              plotBorderWidth: null,
              plotShadow: false
            },
            title: {
              text: "Répartition des dossiers de Professionnel"
            },
            tooltip: {
              pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>"
            },
            plotOptions: {
              pie: {
                allowPointSelect: true,
                cursor: "pointer",

                dataLabels: {
                  enabled: false
                },

                showInLegend: true
              }
            },
            series: [
              {
                type: "pie",
                name: "Pourcentage",
                data: data
              }
            ]
          };
          if (data.length > 0) {
            this.updateFlagPourcentage = true;
          }
        },
        error => {
          console.log(error);
        }
      );
  }

  pourcentageDossierByTypeMarcheCorporate() {
    this._dashboardImpayeServiceService
      .pourcentageDossierImpayeTypeMarche("CORPORATE")
      .pipe(first())
      .subscribe(
        response => {
          const data = [];
          response.forEach(function(value) {
            data.push({ name: value.name, y: value.valeur });
          });
          this.hasDataPourcentageCorporate = data.length > 0;

          this.chartOptionsPourcentageCorporate = {
            chart: {
              plotBorderWidth: null,
              plotShadow: false
            },
            title: {
              text: "Répartition des dossiers de Corporate"
            },
            tooltip: {
              pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>"
            },
            plotOptions: {
              pie: {
                allowPointSelect: true,
                cursor: "pointer",

                dataLabels: {
                  enabled: false
                },

                showInLegend: true
              }
            },
            series: [
              {
                type: "pie",
                name: "Pourcentage",
                data: data
              }
            ]
          };
          if (data.length > 0) {
            this.updateFlagPourcentage = true;
          }
        },
        error => {
          console.log(error);
        }
      );
  }

  getPageDossier(filter: string, pageIndex: number): void {
    if (!this.sort || !this.paginator) {
      console.error("MatSort ou MatPaginator non initialisé.");
      return;
    }

    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = pageIndex;
    });

    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this._dashboardImpayeServiceService.findAllPagingDossierImpayen(
            filter,
            this.paginator.pageIndex,
            this.paginator.pageSize,
            this.sort.active,
            this.sort.direction
          );
        }),
        map(data => {
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.totalElements;
          return data.content;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      )
      .subscribe(data => {
        this.dossiers = data;
      });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.getPageDossier(filterValue, 0);
  }
}
